import styled from '@emotion/styled'

export default styled('div')`
  margin-bottom: ${props => props.theme.spacing['5']};
`
